import _isFunction from "lodash/isFunction";
const mapFieldErrors = ({
  fieldErrors = [],
  errorMappers = {},
  defaultErrorMapper = error => error
}) => fieldErrors.map(error => {
  const errorKey = typeof error === 'string' ? error : error.key;
  const errorMapper = errorMappers[errorKey];
  return _isFunction(errorMapper) ? errorMapper(error) : defaultErrorMapper(error);
});
export default mapFieldErrors;